import { render } from "./ChartComponent.vue?vue&type=template&id=2160d2d2&ts=true"
import script from "./ChartComponent.vue?vue&type=script&lang=ts"
export * from "./ChartComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/rentasdhelos.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__